import React, { useEffect } from "react";
import { QueryStringConsumer, QueryStringProvider } from "app/context/QueryStringContext";
import { useOrganizationTitle } from "app/hooks";
import StoriesSlider from "components/stories/StoriesSlider";

const queryToOptions = queryString => {
  const { i, d, l, s, cl, cy, p, de, v, sp } = queryString;

  return {
    interestIds: i || null,
    departmentIds: d || null,
    locationIds: l || null,
    skillIds: s || null,
    clubIds: cl || null,
    classYearIds: cy || null,
    programIds: p || null,
    degreeIds: de || null,
    organizationValueIds: v || null,
    storyPromptIds: sp || null
  };
};

const queryStringParsers = {
  i: "intList",
  d: "intList",
  l: "intList",
  s: "intList",
  cl: "intList",
  cy: "intList",
  p: "intList",
  de: "intList",
  v: "intList",
  sp: "intList"
};


const LandingPageStoriesCalloutContext = ({ queryString, orgName }) => {
  const { updateSeoTitle } = useOrganizationTitle();
  const organization = orgName.split("-").join(" ");

  useEffect(() => updateSeoTitle(organization), [organization, updateSeoTitle]);

  return (
    <div className="LandingPageCallout LandingPageStoriesCallout">
      <div className="LandingPageCallout--Preview">
        <div className="Preview">
          <div className="Preview-Body">
            <div className="EmbedStories EmbedStories--SliderCallout">
              <StoriesSlider
                hideLinks
                organization={organization}
                redirectCloseAction={false}
                stories={[]}
                queryOptions={queryToOptions(queryString)}
                orgName={organization}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


const LandingPageStoriesCallout = props => (
  <QueryStringProvider parsers={queryStringParsers}>
    <QueryStringConsumer>
      {queryStringContext => (
        <LandingPageStoriesCalloutContext
          {...props}
          {...queryStringContext}
        />
      )}
    </QueryStringConsumer>
  </QueryStringProvider>
);


export default LandingPageStoriesCallout;
